import { Association } from '@/components/bulkUpload/Association';
import { StepButtons } from '@/components/multistep/Questionnaire';
import { useCreateManufacturer, useManufacturers } from '@/services/api/hooks/catalog';
import { useCSV, useMap, useResult } from '@/services/csv/useCSVService';
import { Maps } from '../helpers/enum';
import { useMismatchedManufacturers } from '../helpers/getMismatched';
import { Result } from './UploadFinanceModelStep';

export const ReviewFinanceModelManufacturersStep = () => {
  const result = useResult<Result>();
  if (!result) throw Error('No result');
  const [manufacturers] = useManufacturers();
  const createManufacturer = useCreateManufacturer();
  const uniqueAndNewManufacturers = useMismatchedManufacturers(result, manufacturers);
  const addMapAssociation = useCSV(state => state.addMapAssociation);
  const manufacturerMap = useMap(Maps.Manufacturer);

  const canGoNext = uniqueAndNewManufacturers.reduce((acc, m) => {
    return acc && manufacturerMap?.[m] !== undefined;
  }, true);

  return (
    <div className="flex flex-col gap-3">
      <div className="grid grid-cols-2 gap-5">
        {uniqueAndNewManufacturers.map(m => (
          <Association
            key={m}
            incoming={m}
            options={manufacturers}
            onCreate={async name => {
              await createManufacturer.mutateAsync({ name });
            }}
            onAssociate={(incoming, choice) => {
              addMapAssociation(Maps.Manufacturer, incoming, choice.id);
            }}
            mapping={manufacturerMap?.[m]}
          />
        ))}
      </div>
      <StepButtons canGoNext={canGoNext} />
    </div>
  );
};
